import { Popover as P } from 'radix-ui';
import { type ReactNode } from 'react';

import { cx } from '@/lib/cx';

interface PopoverProps {
  gatilho: ReactNode;
  children: ReactNode;
  aberto?: boolean;
  aoMudar?: (aberto: boolean) => void;
  alinhamento?: 'start' | 'center' | 'end';
  className?: string;
}

export function Popover({
  gatilho,
  children,
  aberto,
  aoMudar,
  alinhamento = 'start',
  className,
}: PopoverProps) {
  return (
    <P.Root
      {...(aberto === undefined ? {} : { open: aberto })}
      {...(aoMudar ? { onOpenChange: aoMudar } : {})}
    >
      <P.Trigger asChild>{gatilho}</P.Trigger>
      <P.Portal>
        <P.Content
          align={alinhamento}
          sideOffset={6}
          className={cx(
            'z-50 rounded-cartao border border-borda bg-superficie-elevada p-2 shadow-alta animate-surgir',
            className,
          )}
        >
          {children}
        </P.Content>
      </P.Portal>
    </P.Root>
  );
}
